import React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import { Button, Box } from "@mui/material";

const StyledContainer = styled(Box)({
  height: "50vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
});

const StyledButton = styled(Button)({
  backgroundColor: "rgba(0, 102, 255, 1)",
  color: "#FFFFFF",
  fontSize: 10,
  fontWeight: "bold",
  marginTop: 10,
  "&:hover": {
    backgroundColor: "rgba(0, 92, 230, 1)",
  },
});

const ErrorPage = ({ error }) => {
  const reload = () => {
    localStorage.clear();
    sessionStorage.clear();
    globalThis.location.href = process.env.REACT_APP_PINGONE_LOGOUT_URL;
  };

  return (
    <StyledContainer>
      {error ? (
        <h2 className="mt-10">{error}</h2>
      ) : (
        <h2 className="mt-10">Oops! Looks like something went wrong.</h2>
      )}
      <StyledButton
        variant="contained"
        size="large"
        onClick={reload}
      >
        Try Re-login
      </StyledButton>
    </StyledContainer>
  );
};

ErrorPage.propTypes = {
  error: PropTypes.string,
};

export default ErrorPage;
